import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/logo@2x.png'


const _hoisted_1 = { class: "name" }
const _hoisted_2 = { class: "highlighted" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.onClose
  }, {
    content: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createTextVNode("Hi,", -1)),
        _createElementVNode("span", _hoisted_2, "  " + _toDisplayString($setup.props.data.firstName) + "!", 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createTextVNode("We sent a confirmation email to", -1)),
        _createElementVNode("span", _hoisted_4, " " + _toDisplayString($setup.props.data.email), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "action" }, "Check your email and click on the confirmation link to continue", -1))
    ]),
    _: 1
  }, 8, ["is-open"]))
}